import client from '../../client'

import {
  HEADER_RECAPTCHA_TOKEN,
  HEADER_RECAPTCHA_ACTION,
  RECAPTCHA_ACTION_LOGIN
} from "../../store/constants/auth";

const tokenConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`
  }
})

export function reqLogin(oauthToken, recaptchaKey) {
  const headers = {
    [HEADER_RECAPTCHA_TOKEN]: recaptchaKey,
    [HEADER_RECAPTCHA_ACTION]: RECAPTCHA_ACTION_LOGIN,
    'X-Access-Token': oauthToken,
  };
  return client().post('/auth/login', {}, {
    headers,
  });
}

export function reqTokenValid(token) {
  return client().get('/auth/is-token-valid', tokenConfig(token))
}

export function reqTokenLogin(newToken) {
  return client().post('/auth/token-login', {
    token: newToken
  })
}
